import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import { axiosFactory } from '@/services/axios-factory'
Vue.use(Vuex);

const {
  VUE_APP_APPNAME,
  VUE_APP_APPKEY,
  VUE_APP_SSOSERVERURL,
  VUE_APP_LOGINREDIRECTURL
} = process.env


export const store = new Vuex.Store({
  state: {
    loginStatus: false,
    isProvinceManage: false, // 省级管理员
    userInfo: {
      userId: '',
      userName: ''
    }
  },
  // getters: {
  //   is_login: state => !!state.loginStatus
  // },
  mutations: {
    SET_LOGINSTATUS (state, payload) {
      state.loginStatus = payload
    },
    SET_USER_INFO (state, payload) {
      state.userInfo = payload
    },
    IS_PROVINCE_MANAGE (state, payload) {
      state.isProvinceManage = payload
    }
  },
  actions: {
    // checkLoginWithSSO ({ commit }, form) {
    //   commit('SET_LOGINSTATUS', form)
    //   // let number = 0
    //   // window.jQuery.ajax({
    //   //   url: process.env.VUE_APP_SSO_URL + "/login",
    //   //   dataType: "jsonp",
    //   //   success: (res) => {
    //   //     if (res && typeof res === "string") {
    //   //       res = JSON.parse(res);
    //   //       commit('SET_LOGINSTATUS', false);
    //   //       if (res.code === 1001) {
    //   //         // 已经登录了
    //   //         commit('SET_LOGINSTATUS', true)
    //   //         // services.userInfo().then((res) => {
    //   //         //   this.$store.commit("SET_USERNAME", res.userName);
    //   //         // });
    //   //       }
    //   //     }
    //   //   },
    //   // });
    // },
    // 判断是否登录
    LoginState ({ commit }) {
      return new Promise((resolve, reject) => {
        // SSO配置
        window.SSO.appName = VUE_APP_APPNAME
        window.SSO.appKey = VUE_APP_APPKEY
        window.SSO.SSOServerUrl = VUE_APP_SSOSERVERURL
        window.SSO.loginRedirectUrl = VUE_APP_LOGINREDIRECTURL
        // 登录状态
        window.SSO.getLoginState((res) => {
          const isLogin = res.code === 1001
          commit('SET_LOGINSTATUS', isLogin)
           
          if (isLogin) {
            window.localStorage.setItem('st', res.data.st)
            window.localStorage.setItem('tgt', res.data.tgt)
            resolve(res.data)
          } else {
            
            console.log("当前路由的值时", router.app._route)

            if (RegExp(/manage/).test(router.app._route.path)) window.location.href = VUE_APP_LOGINREDIRECTURL
            // if (router.app._route.search('manage') != -1) window.location.href = VUE_APP_LOGINREDIRECTURL
            reject(res)
          }
        })
      })
    },
    // 获取用户信息
    GetUsetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        axiosFactory({ url: 'user/getUserName' })
          .then(res => {
            const { code, data } = res
            if (code === '1') {
              let isProvinceManage = false
              if (data.roleCode && data.roleCode.length > 0) {
                const found = data.roleCode.find(item => item.enName === 'provincemanage')
                isProvinceManage = found ? true : false
              }
              commit('IS_PROVINCE_MANAGE', isProvinceManage)
              commit('SET_USER_INFO', data)
              resolve(data)
            } else {
              reject(data)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    // 退出登录
    Logout ({ commit }) {
      return new Promise((resolve) => {
        window.SSO.logout((res) => {
          localStorage.clear()
          commit('SET_LOGINSTATUS', false)
          resolve(res)
        })
      })
    }
  }
})